// --- GSAP等の設定 ----
// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import { CustomEase } from "gsap/CustomEase.js"; // カスタムイージング作成が必要なときは使用

gsap.registerPlugin(ScrollTrigger);




document.addEventListener('DOMContentLoaded', function(event) {

// --- scrollEffect ---
  if (document.querySelector('.js-slideup')) {
    document.querySelectorAll('.js-slideup').forEach(elm => {

      ScrollTrigger.create({
        toggleActions: 'play pause resume reset',
        trigger: elm,
        start: `top bottom`,
        onEnter: function() {
          elm.classList.remove('init');
        },
        onLeaveBack: function() {
          elm.classList.add('init');
        },
      });
    });
  }

});

